import { render, staticRenderFns } from "./Versichererabrechnung.vue?vue&type=template&id=27427d59&"
import script from "./Versichererabrechnung.vue?vue&type=script&lang=js&"
export * from "./Versichererabrechnung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports